// Static roles live directly on the user document. Institution-specific,
// numeric roles continue to come from institution_roles_model.
export const STATIC_ROLES = {
    STUDENT: 0,
    SCHOOL_ADMIN: 'school_admin',
    IT_ACCESS: 'it_access',
}

export const SCHOOL_ADMIN_ROLE = STATIC_ROLES.SCHOOL_ADMIN
export const IT_ACCESS_ROLE = STATIC_ROLES.IT_ACCESS

export const isItAccess = (user) => user?.role === IT_ACCESS_ROLE

export const isAdmin = (user) =>
    user?.role === SCHOOL_ADMIN_ROLE || user?.role_coverage?.target_text === 'All students'
